import { containerConfig } from '../configs/containerConfig';

const Container = ({ children, size, className }) => {
  const config = containerConfig[size] || containerConfig.medium;
  return <div className={`w-full ${config.maxWidth} mx-auto ${config.margin} ${className}`}>{children}</div>;
}

export default Container